function StatsCards({ stats }) {
  const calculateGrowthRate = (current, previous) => {
    if (!previous || previous === 0) return 0;
    return Math.round(((current - previous) / previous) * 100);
  };

  const engagementRate = stats.totalPins > 0 
    ? ((stats.totalLikes + stats.totalComments) / stats.totalPins).toFixed(1)
    : 0;

  const approvalRate = stats.totalPins > 0
    ? Math.round((stats.approvedPins / stats.totalPins) * 100)
    : 0;

  const avgViewsPerPin = stats.totalPins > 0
    ? Math.round(stats.totalViews / stats.totalPins)
    : 0;

  const avgLikesPerPin = stats.totalPins > 0
    ? Math.round(stats.totalLikes / stats.totalPins)
    : 0;

  return (
    <>
      {/* Main Stats - Row 1 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <div className="bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transition-all hover:scale-105 animate-fade-in-up">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <span className="material-symbols-rounded text-4xl">pending</span>
            </div>
            {stats.pendingPins > 0 && (
              <span className="text-xs bg-white/30 px-3 py-1.5 rounded-full font-bold animate-pulse">
                Cần xử lý!
              </span>
            )}
          </div>
          <h3 className="text-sm font-medium opacity-90 mb-1">Chờ duyệt</h3>
          <p className="text-4xl font-bold mb-2">{stats.pendingPins || 0}</p>
          <div className="flex items-center gap-2 text-xs opacity-80">
            <span className="material-symbols-rounded text-[16px]">schedule</span>
            <span>Cần xem xét ngay</span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600 rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transition-all hover:scale-105 animate-fade-in-up stagger-1">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <span className="material-symbols-rounded text-4xl">group</span>
            </div>
            <div className="text-right">
              <span className="text-xs bg-white/30 px-3 py-1.5 rounded-full font-bold block">
                +{stats.newUsers || 0} tuần
              </span>
            </div>
          </div>
          <h3 className="text-sm font-medium opacity-90 mb-1">Tổng Users</h3>
          <p className="text-4xl font-bold mb-2">{stats.totalUsers || 0}</p>
          <div className="flex items-center gap-2 text-xs opacity-80">
            <span className="material-symbols-rounded text-[16px]">trending_up</span>
            <span>Tăng trưởng tốt</span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-500 via-green-600 to-emerald-600 rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transition-all hover:scale-105 animate-fade-in-up stagger-2">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <span className="material-symbols-rounded text-4xl">check_circle</span>
            </div>
            <div className="text-right">
              <span className="text-xs bg-white/30 px-3 py-1.5 rounded-full font-bold">
                {approvalRate}%
              </span>
            </div>
          </div>
          <h3 className="text-sm font-medium opacity-90 mb-1">Đã duyệt</h3>
          <p className="text-4xl font-bold mb-2">{stats.approvedPins || 0}</p>
          <div className="flex items-center gap-2 text-xs opacity-80">
            <span className="material-symbols-rounded text-[16px]">verified</span>
            <span>+{stats.newPins || 0} tuần này</span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-red-500 via-red-600 to-pink-600 rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transition-all hover:scale-105 animate-fade-in-up stagger-3">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <span className="material-symbols-rounded text-4xl">cancel</span>
            </div>
            <div className="text-right">
              <span className="text-xs bg-white/30 px-3 py-1.5 rounded-full font-bold">
                {stats.totalPins > 0 ? Math.round((stats.rejectedPins / stats.totalPins) * 100) : 0}%
              </span>
            </div>
          </div>
          <h3 className="text-sm font-medium opacity-90 mb-1">Đã từ chối</h3>
          <p className="text-4xl font-bold mb-2">{stats.rejectedPins || 0}</p>
          <div className="flex items-center gap-2 text-xs opacity-80">
            <span className="material-symbols-rounded text-[16px]">block</span>
            <span>Vi phạm quy định</span>
          </div>
        </div>
      </div>

      {/* Engagement Stats - Row 2 */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border-2 border-pink-100 dark:border-pink-900/30 hover:border-pink-300 dark:hover:border-pink-700 transition-all hover:scale-105 animate-fade-in-up stagger-4">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-red-500 rounded-xl flex items-center justify-center">
              <span className="material-symbols-rounded text-3xl text-white">favorite</span>
            </div>
            <span className="text-xs font-bold text-pink-600 dark:text-pink-400 bg-pink-50 dark:bg-pink-900/30 px-2 py-1 rounded-full">
              {avgLikesPerPin}/pin
            </span>
          </div>
          <h3 className="text-sm text-gray-600 dark:text-gray-400 mb-1 font-medium">Tổng Likes</h3>
          <p className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{stats.totalLikes || 0}</p>
          <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
            <span className="material-symbols-rounded text-[14px]">thumb_up</span>
            <span>Trung bình {avgLikesPerPin} likes/prompt</span>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border-2 border-blue-100 dark:border-blue-900/30 hover:border-blue-300 dark:hover:border-blue-700 transition-all hover:scale-105 animate-fade-in-up stagger-5">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
              <span className="material-symbols-rounded text-3xl text-white">comment</span>
            </div>
            <span className="text-xs font-bold text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 px-2 py-1 rounded-full">
              {stats.totalPins > 0 ? (stats.totalComments / stats.totalPins).toFixed(1) : 0}/pin
            </span>
          </div>
          <h3 className="text-sm text-gray-600 dark:text-gray-400 mb-1 font-medium">Tổng Comments</h3>
          <p className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{stats.totalComments || 0}</p>
          <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
            <span className="material-symbols-rounded text-[14px]">forum</span>
            <span>Tương tác tích cực</span>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border-2 border-purple-100 dark:border-purple-900/30 hover:border-purple-300 dark:hover:border-purple-700 transition-all hover:scale-105 animate-fade-in-up stagger-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center">
              <span className="material-symbols-rounded text-3xl text-white">visibility</span>
            </div>
            <span className="text-xs font-bold text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/30 px-2 py-1 rounded-full">
              {avgViewsPerPin}/pin
            </span>
          </div>
          <h3 className="text-sm text-gray-600 dark:text-gray-400 mb-1 font-medium">Tổng Views</h3>
          <p className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{stats.totalViews || 0}</p>
          <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
            <span className="material-symbols-rounded text-[14px]">trending_up</span>
            <span>Trung bình {avgViewsPerPin} views/prompt</span>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border-2 border-indigo-100 dark:border-indigo-900/30 hover:border-indigo-300 dark:hover:border-indigo-700 transition-all hover:scale-105 animate-fade-in-up stagger-7">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center">
              <span className="material-symbols-rounded text-3xl text-white">dashboard</span>
            </div>
            <span className="text-xs font-bold text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 px-2 py-1 rounded-full">
              {stats.totalPins > 0 ? (stats.totalPins / stats.totalBoards).toFixed(0) : 0}/board
            </span>
          </div>
          <h3 className="text-sm text-gray-600 dark:text-gray-400 mb-1 font-medium">Tổng Boards</h3>
          <p className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{stats.totalBoards || 0}</p>
          <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
            <span className="material-symbols-rounded text-[14px]">category</span>
            <span>Danh mục đa dạng</span>
          </div>
        </div>
      </div>

    
    </>
  );
}

export default StatsCards;
